export default __webpack_public_path__ + "static/media/mobile-app.4cf95ab3.png";